import React, { useState } from "react";

const ideas = [
  "Share your morning routine 🌅",
  "Post a behind-the-scenes photo of your work",
  "Create a poll to engage your audience 📊",
  "Show a before-and-after of your process",
  "Give a shout-out to another creator 💬",
  "Share a motivational quote you love ✨",
  "Talk about a mistake you learned from 🎯",
  "Post something that shows your personality 😄",
  "Highlight your favorite tool or app 🛠️",
  "Ask your audience a question 💭"
];

export default function SuggestionBox() {
  const [suggestion, setSuggestion] = useState("");

  const getRandomSuggestion = () => {
    const random = ideas[Math.floor(Math.random() * ideas.length)];
    setSuggestion(random);
  };

  return (
    <div
      style={{
        maxWidth: "500px",
        margin: "40px auto",
        padding: "25px",
        textAlign: "center",
        backgroundColor: "#f9faf9",
        borderRadius: "12px",
        boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
      }}
    >
      <h2 style={{ color: "#3b3b3b", marginBottom: "15px" }}>Need Inspiration?</h2>
      <p style={{ fontSize: "15px", color: "#555" }}>
        Click below for a random content idea 💡
      </p>

      <button
        onClick={getRandomSuggestion}
        style={{
          backgroundColor: "#6b8a78",
          color: "white",
          border: "none",
          padding: "10px 20px",
          borderRadius: "6px",
          cursor: "pointer",
          marginTop: "10px",
          transition: "background 0.3s ease",
        }}
        onMouseEnter={(e) => (e.target.style.backgroundColor = "#587362")}
        onMouseLeave={(e) => (e.target.style.backgroundColor = "#6b8a78")}
      >
        Give me an idea
      </button>

      {suggestion && (
        <div
          style={{
            marginTop: "20px",
            padding: "15px",
            backgroundColor: "#e3e9e3",
            borderRadius: "8px",
            fontStyle: "italic",
            color: "#333",
            boxShadow: "inset 0 1px 4px rgba(0,0,0,0.1)",
          }}
        >
          {suggestion}
        </div>
      )}
    </div>
  );
}
